export default Object.freeze({
  SqlServer: 0,
  Access: 1,
  MySql: 2,
});
